import { useMemo } from 'react'
import { Divider, Grid } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-pro'

import SimpleTable from '../../../../components/simple-table'

import { ShipToInformation } from './order-accordion-details'

const columns = [
  {
    field: 'device',
    headerName: 'Devices Being Replaced',
    width: 400,
    sortable: false,
  },
  {
    field: 'location',
    headerName: 'Location',
    flex: 1,
    sortable: false,
  },
  {
    field: 'locationNote',
    headerName: 'Note',
    flex: 1,
    sortable: false,
  },
] satisfies GridColDef[]

const ReorderAccordionDetails = ({
  expandedDetails,
  shipToAddress,
}: {
  expandedDetails: IReorderItemExpanded
  shipToAddress: IOrderListItem['shipToAddress']
}) => {
  const rows = useMemo(
    () =>
      expandedDetails.devices.map((d, idx) => ({
        id: idx,
        device: [d.name, d.uniqueId].join(' • '),
        location: d.location,
        locationNote: d.note,
      })),
    [expandedDetails.devices]
  )

  return (
    <Grid
      container={true}
      sx={{
        gap: 2,
      }}
    >
      <Grid size={8.9}>
        <SimpleTable columns={columns} rows={rows} />
      </Grid>
      <Grid size="auto">
        <Divider orientation="vertical" variant="middle" />
      </Grid>
      <Grid
        size="grow"
        sx={{
          paddingTop: 1,
        }}
      >
        <ShipToInformation shipToAddress={shipToAddress} />
      </Grid>
    </Grid>
  )
}

export default ReorderAccordionDetails
